export enum ContextoIntegracaoGRPEnum {
  GUIA = "Guia",
  BAIXA_GUIA = "Baixa de Guia",
  CADASTRO = "Cadastro"
}
